<template>
    <div class="catolog">
        <b-container fluid>
            <b-row>
                <b-col md="6" class="bottomv">
                    <h1 class="mb">Products Catalog</h1>
                    <img src="../assets/img/img_catalog.jpg" class="img-fluid" alt="">
                </b-col>
                <b-col md="6">
                    <p class="bullets"><img src="../assets/img/icn_arrow.svg" alt=""> Cooking Equipment</p>
                    <p class="bullets"><img src="../assets/img/icn_arrow.svg" alt=""> Commercial Refrigeration</p>
                    <p class="bullets"><img src="../assets/img/icn_arrow.svg" alt=""> Commercial Ovens</p>
                    <p class="bullets"><img src="../assets/img/icn_arrow.svg" alt=""> Commercial Work Tables and Stations</p>
                    <p class="bullets"><img src="../assets/img/icn_arrow.svg" alt=""> Faucets and Plumbing</p>
                    <p class="bullets"><img src="../assets/img/icn_arrow.svg" alt=""> Beverage equipment</p>
                    <p class="bullets"><img src="../assets/img/icn_arrow.svg" alt=""> Food preparation equipment</p>
                    <p class="bullets"><img src="../assets/img/icn_arrow.svg" alt=""> Food Display and Merchandising</p>
                    <p class="bullets mb"><img src="../assets/img/icn_arrow.svg" alt=""> Smallwares</p>
                    <a href="pdf/BrochureProvincoKitchenSolutionsEng.pdf" class="btn" download>Download Catalog</a>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
.catolog{
    padding: 10% 5%;
}
.bullets{
    font-size: 35px;
}
.bullets img{
    margin-top: -6px;
    margin-right: 15px;
}
.btn{
    background: #C80B4B;
    border-color: #C80B4B;
    color: #fff;
    outline: 0;
    width: 100%;
    font-size: 30px;
}
.btn:focus,
.btn:hover,
.btn:active{
    color: #fff;
    background: #C80B4B !important;
    border-color: #C80B4B !important;
}
.mb{
    margin-bottom: 3rem !important;
}
@media (max-width: 1600px){
    h1{
        font-size: 45px;
    }
    .bullets{
        font-size: 28px;
        margin-bottom: 10px;
    }
    .btn{
        font-size: 21px;
    }
    .bullets img{
        width: 28px;
    }
}

@media (max-width: 768px){
    h1{
        font-size: 35px;
    }
    .bullets{
        font-size: 20px;
        margin-bottom: 5px;
        padding-left: 30px;
        position: relative;
    }
    .btn{
        font-size: 21px;
    }
    .bullets img{
        position: absolute;
        width: 20px;
        margin-top: 5px;
        margin-left: -30px;
    }
    .mb{
        margin-bottom: 2rem;
    }
    .img-fluid{
        margin-bottom: 2rem;
    }
    .catolog{
        padding: 15% 5%;
    }
}
</style>